import { LOCATIONS_LIST, LOCATIONS_PAGINATION } from "./constant";


export const initStateFeed = {
    locationList: [],
    pagination: {},
};

export default (state = initStateFeed, action) => {
    switch (action.type) {
        case LOCATIONS_LIST: {
            return {
                ...state,
                locationList: action.payload,
            };
        }
        case LOCATIONS_PAGINATION: {
            return {
                ...state,
                pagination: action.payload,
            };
        }
        default:
            return state;
    }
};
 